import { SPACING_TOKEN_MAP } from '../constants';
import type { SpacingToken } from '../types';
import { SPACING_PROP_VAR } from './constants';
import type { SpacingProp } from './types';

export const isWideSpacingToken = (value: SpacingToken): boolean =>
  typeof value === 'string' && value.endsWith('--wide');

export const getSpacingVars = (
  spacingProps: Partial<Record<SpacingProp, SpacingToken>>,
): Record<string, string> =>
  (Object.entries(spacingProps) as Array<[SpacingProp, SpacingToken | undefined]>).reduce<
    Record<string, string>
  >((acc, [prop, value]) => {
    if (value === undefined) return acc;
    const baseVar = SPACING_PROP_VAR[prop];
    const tokenName = SPACING_TOKEN_MAP[value];
    const varName = isWideSpacingToken(value) ? `${baseVar}-md` : baseVar;
    acc[varName] = tokenName;
    return acc;
  }, {});
